import List from "@/components/list";
import router from "@/router";

const Table = args => {
  const { listeners, props } = args;
  const RCSelectionChange = args.listeners["selection-change"] || function () { };
  const handleDelete = listeners["handleDelete"] || function () { };

  const Deal = ({ props: { vo } }) => {
    let dealConf = [];
    dealConf.push(["icon-delete", "移除", () => handleDelete(vo.row), "topicLecture:user:delete"]);
    
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const ClassName = ({ props: { vo } }) => {
    const item = vo.row;
    return (
      <span class="ellipsis--l2">{item.className}</span>
    )
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
    },
    {
      label: "姓名",
      width: "120",
      prop: "userName",
      showOverflowTooltip: true,
    },
    {
      label: "工作单位",
      minWidth: "160",
      prop: "deptName",
      showOverflowTooltip: true,
    },
    {
      label: "单位及职务",
      prop: "unitPosition",
      minWidth: "180",
      showOverflowTooltip: true,
    },
    // {
    //   label: "签到时间",
    //   prop: "signDate",
    //   width: "160",
    // },
    // {
    //   label: "签到类型",
    //   prop: "signTypeStr",
    //   width: "140",
    // },
    {
      label: "操作",
      width: "60",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];
  if (args.props.isScanSign == 1) {
    AccountTableConfig.splice(4, 0, {
      label: "签到时间",
      prop: "signDate",
      width: "160",
    }, {
      label: "签到类型",
      prop: "signTypeStr",
      width: "140",
    });
  }

  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
